<template>
  <input
    type="range"
    :min="min"
    :step="step"
    :max="max"
    class="cursor-pointer w-1/2 border border-solid border-grey"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  name: 'SliderInput',
  props: {
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    step: {
      type: Number,
      required: false,
      default: 1
    },
    lazy: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    inputListeners() {
      const vm = this;
      /**
       * This is a workaround as the `v-model.lazy` seems not be working properly on custom components
       */
      if (this.lazy) {
        return Object.assign({}, this.$listeners, {
          input: () => {},
          change: event => vm.$emit('input', event.target.value)
        });
      }
      return Object.assign({}, this.$listeners, {
        input: event => vm.$emit('input', event.target.value)
      });
    }
  }
};
</script>
